<template>
  <Form ref="formRef"
        :model="props.record"
        :label-col="labelCol"
        :wrapper-col="wrapperCol">
    <div v-if="props.record?.refLabTopic?.refLabFormula?.key === 'n c m M'">
      <FormItem label="n">
        <InputNumber v-model:value="props.record.n" placeholder="input n"/>
      </FormItem>
      <FormItem label="c">
        <InputNumber v-model:value="props.record.c" placeholder="input c"/>
      </FormItem>
      <FormItem label="m">
        <InputNumber v-model:value="props.record.m" placeholder="input m"/>
      </FormItem>
      <FormItem label="M">
        <InputNumber v-model:value="props.record.mUpper" placeholder="input M"/>
      </FormItem>
      <FormItem :wrapper-col="{ span: 14, offset: 4 }">
      </FormItem>
    </div>
    <div v-if="props.record?.refLabTopic?.refLabFormula?.key === 'Operator'">
      <FormItem ref="mathSymbol" label="Math Symbol" name="mathSymbol">
        <Select v-model:value="props.record.mathSymbol"
                placeholder="please select math symbol">
          <SelectOption v-for="item in mathSymbolSelectItems" :key="item" :value="item">
            {{ item }}
          </SelectOption>
        </Select>
      </FormItem>
      <FormItem :wrapper-col="{ span: 14, offset: 4 }">
      </FormItem>
      <FormItem ref="operatorValue" label="Operator Value" name="operatorValue">
        <InputNumber v-model:value="props.record.operatorValue"
                     :allowPrecision="true"
                     :maxPrecision="4"
                     :comma="false"
        ></InputNumber>
      </FormItem>
      <FormItem :wrapper-col="{ span: 14, offset: 4 }">
      </FormItem>
    </div>
    <div v-if="props.record?.refLabTopic?.refLabFormula?.key === 'Accept/Reject'">
      <FormItem ref="isAccept" label="Accept" name="isAccept" class="text-left">
        <Checkbox :checked="props.record.isAccept"
                  @change="(e) => props.record.isAccept = e.target.checked"
        ></Checkbox>
      </FormItem>
    </div>
    <div v-if="props.record?.refLabTopic?.refLabFormula?.key === 'Detected'">
      <FormItem ref="isDetected" label="Detected" name="isDetected" class="text-left">
        <Checkbox :checked="props.record.isDetected"
                  @change="(e) => props.record.isDetected = e.target.checked"
        ></Checkbox>
      </FormItem>
    </div>
  </Form>
</template>
<script>
import {defineComponent, ref} from 'vue';

import {Form, Select, Checkbox} from 'ant-design-vue';
import InputNumber from "../../../../../components/input/template-builder/input-number/InputNumber";

export default defineComponent({
  components: {
    Form,
    FormItem: Form.Item,
    InputNumber: InputNumber,
    Select,
    SelectOption: Select.Option,
    Checkbox,
  },
  props: {
    record: {},
  },
  methods: {},
  setup(props) {
    const formRef = ref()
    const mathSymbolSelectItems = ['=', '>', '<', '>=', '<=']

    return {
      formRef,
      mathSymbolSelectItems,
      labelCol: {
        span: 6,
      },
      wrapperCol: {
        span: 12,
      },
      other: '',
      props,
    };
  },
});
</script>
